import React from 'react';
import classnames from 'classnames';
import { ImageProps } from 'components/Image/props';

import ImageComponent from './ImageComponent';

export default function ImageContainer(props: ImageProps) {
  const {
    border,
    borderContainerClassName,
  } = props;

  if (!border) {
    return <ImageComponent {...props} />;
  }

  return (
    <div
      className={classnames(
        getBorderClasses(border),
        borderContainerClassName,
      )}
    >
      <ImageComponent {...props} />
    </div>
  );
}

ImageContainer.displayName = 'ImageContainer';

function getBorderClasses(border: Pick<ImageProps, 'border'>) {
  return classnames({
    'card-border': border,
    'card-gold': border === 'gold',
    'card-silver': border === 'silver',
    'card-bronze': border === 'bronze',
    'card-black': border === 'black',
    'card-red': border === 'red',
    'card-purple': border === 'purple',
  });
}
